export default ["N", "NE", "E", "SE", "S", "SW", "W", "NW", "C"];
